import { DrawingPad, type DrawingPadHandle } from '../../components/DrawingPad/index.js';
import styles from './NeighborsSection.module.css';

export interface NeighborsSectionProps {
  registerPad: (handle: DrawingPadHandle | null) => void;
  /** When false, render the pads as plain shells so the board's pen
   *  overlay can annotate them directly. */
  drawingEnabled?: boolean;
}

export function NeighborsSection({ registerPad, drawingEnabled = true }: NeighborsSectionProps) {
  return (
    <section className={styles.section} data-testid="neighbors-section">
      <h2>Number neighbors</h2>
      <div className={styles.row}>
        <div className={styles.padWrap}>
          <span className={styles.label}>10 less</span>
          <DrawingPad
            ref={drawingEnabled ? registerPad : undefined}
            width={180}
            height={120}
            ariaLabel="10 less"
            disabled={!drawingEnabled}
          />
        </div>
        <div className={styles.padWrap}>
          <span className={styles.label}>10 more</span>
          <DrawingPad
            ref={drawingEnabled ? registerPad : undefined}
            width={180}
            height={120}
            ariaLabel="10 more"
            disabled={!drawingEnabled}
          />
        </div>
      </div>
    </section>
  );
}
